import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { normalizeAssignmentPermission } from './assignment-permission';
import { Entity, Guard, Result } from '@digibricks/core';
import { ConfigType } from '../data-config';
import { FormReleaseInfo } from './form-release-info';
import { AssignmentMetadata } from '../assignment-metadata';
import { UnixTimestamp } from '../unix-timestamp';
export var Assignment = /*#__PURE__*/function (_Entity) {
  _inherits(Assignment, _Entity);

  var _super = _createSuper(Assignment);

  function Assignment() {
    _classCallCheck(this, Assignment);

    return _super.apply(this, arguments);
  }

  _createClass(Assignment, [{
    key: "version",
    get: function get() {
      var _this$props$version;

      return (_this$props$version = this.props.version) !== null && _this$props$version !== void 0 ? _this$props$version : 1;
    }
  }, {
    key: "canManage",
    get: function get() {
      return this.props.canManage !== false;
    }
  }, {
    key: "permission",
    get: function get() {
      return normalizeAssignmentPermission(this.props.permission);
    }
  }, {
    key: "idNumber",
    get: function get() {
      return this.props.idNumber;
    }
  }, {
    key: "title",
    get: function get() {
      return this.props.title;
    }
  }, {
    key: "description",
    get: function get() {
      return this.props.description;
    }
  }, {
    key: "duration",
    get: function get() {
      return this.props.duration;
    }
  }, {
    key: "type",
    get: function get() {
      return this.props.type;
    }
  }, {
    key: "password",
    get: function get() {
      return this.props.password;
    }
  }, {
    key: "isShuffleQuestion",
    get: function get() {
      return this.props.isShuffleQuestion;
    }
  }, {
    key: "isShuffleAnswer",
    get: function get() {
      return this.props.isShuffleAnswer;
    }
  }, {
    key: "hasPassword",
    get: function get() {
      return this.props.hasPassword;
    }
  }, {
    key: "startTime",
    get: function get() {
      return this.props.startTime;
    }
  }, {
    key: "completedAt",
    get: function get() {
      var _this$props$completed;

      return (_this$props$completed = this.props.completedAt) !== null && _this$props$completed !== void 0 ? _this$props$completed : null;
    }
  }, {
    key: "effectiveEndTime",
    get: function get() {
      return Assignment.getEffectiveEndTime(this);
    }
  }, {
    key: "isUpcoming",
    value: function isUpcoming() {
      return Assignment.isUpcoming(this);
    }
  }, {
    key: "isOngoing",
    value: function isOngoing() {
      return Assignment.isOngoing(this);
    }
  }, {
    key: "endTime",
    get: function get() {
      return this.props.endTime;
    }
  }, {
    key: "formReleaseInformation",
    get: function get() {
      return this.props.formReleaseInformation;
    }
  }, {
    key: "systemStatus",
    get: function get() {
      return this.props.systemStatus;
    }
  }, {
    key: "displayStatus",
    get: function get() {
      return this.props.displayStatus;
    }
  }, {
    key: "numberOfSubmission",
    get: function get() {
      return this.props.numberOfSubmission;
    }
  }, {
    key: "createdBy",
    get: function get() {
      return this.props.createdBy;
    }
  }, {
    key: "expectation",
    get: function get() {
      return this.props.expectation;
    }
  }, {
    key: "expectationUnit",
    get: function get() {
      return this.props.expectationUnit || 'percentage';
    }
  }, {
    key: "assigner",
    get: function get() {
      return this.props.assigner;
    }
  }, {
    key: "isShowingScore",
    get: function get() {
      return this.props.isShowingScore;
    }
  }, {
    key: "isShowingExplanationAndCorrectAnswers",
    get: function get() {
      return this.props.isShowingExplanationAndCorrectAnswers;
    }
  }, {
    key: "metadata",
    get: function get() {
      return this.props.metadata;
    }
  }, {
    key: "isEnded",
    value: function isEnded() {
      if (this.completedAt) return true;
      var end = UnixTimestamp.parseMilliseconds(this.endTime);
      return end !== null && Date.now() > end;
    }
  }], [{
    key: "getEffectiveEndTime",
    value: function getEffectiveEndTime(_ref) {
      var endTime = _ref.endTime,
          completedAt = _ref.completedAt;
      var endMilliseconds = UnixTimestamp.parseMilliseconds(endTime);
      var completedMilliseconds = UnixTimestamp.parseMilliseconds(completedAt);
      return completedMilliseconds !== null && (endMilliseconds === null || completedMilliseconds < endMilliseconds) ? completedAt : endTime !== null && endTime !== void 0 ? endTime : null;
    }
  }, {
    key: "isUpcoming",
    value: function isUpcoming(assignment) {
      var start = UnixTimestamp.parseMilliseconds(assignment.startTime);
      return !assignment.completedAt && Assignment.activeSystemStatusIds.includes(assignment.systemStatus.id) && start !== null && start > Date.now();
    }
  }, {
    key: "isOngoing",
    value: function isOngoing(assignment) {
      var now = Date.now();
      var start = UnixTimestamp.parseMilliseconds(assignment.startTime);
      var end = UnixTimestamp.parseMilliseconds(assignment.endTime);
      return !assignment.completedAt && Assignment.activeSystemStatusIds.includes(assignment.systemStatus.id) && (!assignment.startTime || start !== null && start <= now) && (!assignment.endTime || end !== null && end > now);
    }
  }, {
    key: "validateBaseProps",
    value: function validateBaseProps(props) {
      var guardCollections = [{
        argument: props.id,
        argumentName: 'Id'
      }, {
        argument: props.title,
        argumentName: 'Title'
      }, {
        argument: props.type,
        argumentName: 'Type'
      }, {
        argument: props.description,
        argumentName: 'Description'
      }, {
        argument: props.isShuffleQuestion,
        argumentName: 'Is Shuffle Question'
      }, {
        argument: props.systemStatus,
        argumentName: 'System Status'
      }, {
        argument: props.numberOfSubmission,
        argumentName: 'Number of Submissions'
      }, {
        argument: props.isShowingExplanationAndCorrectAnswers,
        argumentName: 'Is Showing Explanation and Correct Answers'
      }];
      var guardResult = Guard.againstNullOrUndefinedBulk(guardCollections);

      if (!guardResult.succeeded) {
        return Result.fail(guardResult.message);
      }

      return Result.ok();
    }
  }, {
    key: "createBasePropsFromJson",
    value: function createBasePropsFromJson(data) {
      try {
        var _data$version;

        var id = data.id,
            idNumber = data.idNumber,
            completedAt = data.completedAt,
            completedBy = data.completedBy,
            formReleaseInformation = data.formReleaseInformation,
            title = data.title,
            description = data.description,
            numberOfSubmission = data.numberOfSubmission,
            type = data.type,
            password = data.password,
            systemStatus = data.systemStatus,
            startTime = data.startTime,
            scoreVisibilityType = data.scoreVisibilityType,
            isShuffleQuestion = data.isShuffleQuestion,
            isShuffleAnswer = data.isShuffleAnswer,
            endTime = data.endTime,
            createdBy = data.createdBy,
            hasPassword = data.hasPassword,
            expectation = data.expectation,
            expectationUnit = data.expectationUnit,
            duration = data.duration,
            isShowingScore = data.isShowingScore,
            isShowingExplanationAndCorrectAnswers = data.isShowingExplanationAndCorrectAnswers,
            metadata = data.metadata;
        var typeOrError = ConfigType.create({
          id: type.id,
          name: type.name
        });

        if (typeOrError.isFailure) {
          return Result.fail(typeOrError.error);
        }

        var systemStatusOrError = ConfigType.create({
          id: systemStatus.id,
          name: systemStatus.name
        });

        if (systemStatusOrError.isFailure) {
          return Result.fail(systemStatusOrError.error);
        }

        var formReleaseInformationOrError = FormReleaseInfo.create({
          id: formReleaseInformation.id,
          version: formReleaseInformation.version,
          formId: formReleaseInformation.formId,
          totalScore: formReleaseInformation.totalScore,
          totalQuestions: formReleaseInformation.totalQuestions
        });

        if (formReleaseInformationOrError.isFailure) {
          return Result.fail(formReleaseInformationOrError.error);
        }

        var props = {
          canManage: data.canManage,
          permission: data.permission,
          permissionMode: data.permissionMode,
          id: id,
          version: (_data$version = data.version) !== null && _data$version !== void 0 ? _data$version : 1,
          idNumber: idNumber,
          completedAt: completedAt,
          completedBy: completedBy,
          title: title,
          description: description,
          numberOfSubmission: numberOfSubmission,
          formReleaseInformation: formReleaseInformationOrError.getValue(),
          type: typeOrError.getValue(),
          password: password,
          hasPassword: hasPassword,
          systemStatus: systemStatusOrError.getValue(),
          createdBy: createdBy,
          startTime: startTime,
          isShuffleQuestion: isShuffleQuestion,
          isShuffleAnswer: isShuffleAnswer,
          endTime: endTime,
          expectation: expectation,
          expectationUnit: expectationUnit || 'percentage',
          duration: duration,
          isShowingScore: isShowingScore,
          isShowingExplanationAndCorrectAnswers: isShowingExplanationAndCorrectAnswers
        };

        if (metadata) {
          var isGradedAllSubmission = metadata.isGradedAllSubmission;
          var metadataOrError = AssignmentMetadata.create({
            isGradedAllSubmission: isGradedAllSubmission
          });

          if (metadataOrError.isFailure) {
            return Result.fail(metadataOrError.error);
          }

          props.metadata = metadataOrError.getValue();
        }

        return Result.ok(props);
      } catch (error) {
        return Result.fail(error);
      }
    }
  }]);

  return Assignment;
}(Entity);

_defineProperty(Assignment, "activeSystemStatusIds", ['3', '5']);